const ENTRY_CONTEXT_KEY = 'entry_context';

export const ENTRY_CONTEXT_GESTION = 'gestion';
export const ENTRY_CONTEXT_PRESUPUESTOS = 'presupuestos';

export function setEntryContext(context) {
  try {
    if (!context) {
      sessionStorage.removeItem(ENTRY_CONTEXT_KEY);
      return;
    }
    sessionStorage.setItem(ENTRY_CONTEXT_KEY, context);
  } catch {}
}

export function getEntryContext() {
  if (typeof window === 'undefined') return '';
  try {
    return sessionStorage.getItem(ENTRY_CONTEXT_KEY) || '';
  } catch {
    return '';
  }
}

export function clearEntryContext() {
  try {
    sessionStorage.removeItem(ENTRY_CONTEXT_KEY);
  } catch {}
}

export function isPresupuestosEntryContext() {
  return getEntryContext() === ENTRY_CONTEXT_PRESUPUESTOS;
}
